import React from "react"

import { Card } from "@/components/ui/card"
import { cn } from "@/lib/utils"
import { Info } from "lucide-react"

export type InfoCardProps = React.PropsWithChildren<{
  variant: "info"
}>

export const InfoCard: React.FC<InfoCardProps> = ({
  variant = "info",
  children,
}) => {
  return (
    <div
      className={cn(
        "not-prose p-4 rounded-lg flex gap-2",
        variant === "info" && "bg-primary/20",
      )}
    >
      <Info className="text-primary mt-0.5" />
      <div>{children}</div>
    </div>
  )
}
